
const helper = vue => ({
  get(url, query, router) {
    return new Promise((resolve) => {
      const qs = query || {};
      vue.http.get(url, { params: qs })
        .then((res) => {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        })
        .catch((err) => {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(Object.assign(err, { success: false }));
        });
    });
  },
  post(url, data, router) {
    return new Promise((resolve) => {
      let reqData = data || {};
      const webShopResourceId = localStorage.getItem('webShopResourceId');
      if (webShopResourceId) {
        reqData = Object.assign(
          reqData,
          {
            webShopResourceId,
          },
        );
      }
      vue.http.post(
        url,
        reqData,
      )
        .then((res) => {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        })
        .catch((err) => {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(Object.assign(err, { success: false }));
        });
    });
  },
  put(url, data, router) {
    return new Promise((resolve) => {
      let reqData = data || {};
      const webShopResourceId = localStorage.getItem('webShopResourceId');
      if (webShopResourceId) {
        reqData = Object.assign(
          reqData,
          {
            webShopResourceId,
          },
        );
      }
      vue.http.put(
        url,
        reqData,
      )
        .then((res) => {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        })
        .catch((err) => {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(Object.assign(err, { success: false }));
        });
    });
  },
  delete(url, data, router) {
    return new Promise((resolve) => {
      let reqData = data || {};
      const webShopResourceId = localStorage.getItem('webShopResourceId');
      if (webShopResourceId) {
        reqData = Object.assign(
          reqData,
          {
            webShopResourceId,
          },
        );
      }
      vue.http.delete(url, { params: reqData })
        .then((res) => {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        })
        .catch((err) => {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(Object.assign(err, { success: false }));
        });
    });
  },
});
/* eslint-disable */
const WebHelper = {
  install(Vue, options) {
    Vue.prototype.$webHelper = helper(Vue);
  },
};

export default WebHelper;



// WEBPACK FOOTER //
// ./src/helpers/web.js